import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { TaskSummaryComponent } from "../../task-summary/task-summary.component";
import { SimpleChanges, OnInit, OnChanges } from "@angular/core";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GenericRequestKanbanDto } from "../../../../core/models/common/genericRequestKanbanDto";
import { GetAllTaskResponse } from "../../../../core/models/task-management/getAllTaskResponseDto";
import { GetTaskSwimLanesDto } from "../../../../core/models/task-management/getTaskSwimLanesDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { PriorityTypeEnums } from "../../../../shared/enums/priorityTypeEnum";
import { EnumSalesTaskStatus } from "../../../../shared/enums/salesTaskStatus";
import { TaskTypeEnum } from "../../../../shared/enums/taskTypeEnum";
import { ViewTypeEnum } from "../../../../shared/enums/viewTypeEnum";
import { WorkflowStatusEnum } from "../../../../shared/enums/workflowStatusEnum";
import {
  getColorForName,
  getTextColorForName,
} from "../../../../shared/globalfunction";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ProjectWorkflowService } from "../../../../core/services/project-workflow.service";
import { CommonModule } from "@angular/common";
import { TagModule } from "primeng/tag";
import { SkeletonModule } from "primeng/skeleton";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";
import { DragDropModule } from "primeng/dragdrop";
import { Popover, PopoverModule } from "primeng/popover";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { avatarUserDetailsDto } from "../../../../core/models/task-management/avatar-user-details";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { UserAvatarDetailsComponent } from "../../user-avatar-details/user-avatar-details.component";
import { DomSanitizer } from "@angular/platform-browser";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { GetUserAvatarDetailsDto } from "../../../../core/models/users/users/getUserAvatarDetailsDto";
import { GetAllAssignedUsers } from "../../../../core/models/task-management/getAllAssignedUsersDto";
import { TaskHeaderEditComponent } from "../../task-header-edit/task-header-edit.component";
//import { Sale } from '../../../models/Sale';

@Component({
  selector: "jni-kanban-view",
  templateUrl: "./kanban-view.component.html",
  styleUrls: ["./kanban-view.component.scss"],
  imports: [
    CommonModule,
    TagModule,
    SkeletonModule,
    DialogModule,
    TooltipModule,
    DragDropModule,
    PopoverModule,
    UserAvatarDetailsComponent,
    TaskHeaderEditComponent,
  ],
})
export class KanbanViewComponent implements OnInit, OnChanges {
  @ViewChild("taskHeaderEdit", { static: false })
  taskHeaderEdit!: TaskHeaderEditComponent;
  @Output() emitShowContactDialog = new EventEmitter<string>();
  @Input() globalFilter!: GenericFilterRequestDto[];
  @Input() taskType!: number;
  @Input() myTasks!: boolean;
  @Input() archivedTasks!: boolean;
  @Input() headerSearchText = "";
  lazyLoadEvent!: GenericFilterRequestDto[];
  @Input() allAssignedUserList: GetAllAssignedUsers[] = [];
  taskIdSelected = 0;
  swimLanes: GetTaskSwimLanesDto[] = [];
  @ViewChild("TaskSummary") child!: TaskSummaryComponent;
  products = [];
  displayAddTaskModal = false;
  displayTaskDetailModal = false;
  showTaskModal = false;
  showSummarykModal = false;
  displaySidebar = false;
  showEditTaskModal = false;
  taskList: GetAllTaskResponse[] = [];
  defaultTake = 250;
  totalRecords = 0;
  //filterTextChanged: Subject<any> = new Subject<any>();
  filterDebounceTime = 1000;
  dropIndex = 0;
  activeListing: Map<string, GetAllTaskResponse[]> = new Map<
    string,
    GetAllTaskResponse[]
  >();
  draggedTask: GetAllTaskResponse | null | undefined;
  dataSet: GetAllTaskResponse[] = [];
  TaskTypeEnum = TaskTypeEnum;
  PriorityTypeEnums = PriorityTypeEnums;
  userAvatorDetails = {} as avatarUserDetailsDto;
  @ViewChild("userAvatarDetailsComp", { static: false })
  userAvatarDetailsComp!: UserAvatarDetailsComponent;
  @ViewChild("avatarPopover", { static: false })
  avatarPopover!: Popover;

  private hideTimeout: ReturnType<typeof setTimeout> | null = null;
  private currentAvatarTarget: HTMLElement | null = null;

  taskStatusKeyPairsSales: Record<number, string> = {
    [EnumSalesTaskStatus.New]: "New",
    [EnumSalesTaskStatus.Blocked]: "Blocked",
    [EnumSalesTaskStatus.InProgress]: "In Progress",
    [EnumSalesTaskStatus.InReview]: "In Review",
    [EnumSalesTaskStatus.Closed]: "Closed",
  };

  taskStatusKeyPairsProduction: Record<number, string> = {
    [WorkflowStatusEnum.ALL]: "All",
    [WorkflowStatusEnum.Cancelled]: "Cancelled",
    [WorkflowStatusEnum.Complete]: "Complete",
    [WorkflowStatusEnum.Delivered]: "Delivered",
    [WorkflowStatusEnum.InProduction]: "In-Production",
    [WorkflowStatusEnum.OrderWritten]: "Order-Written",
    [WorkflowStatusEnum.PoSent]: "Posent",
    [WorkflowStatusEnum.ProjectCreated]: "Project-Created",
    [WorkflowStatusEnum.ProofApproved]: "Proof-Approved",
    [WorkflowStatusEnum.ProofSent]: "Proof-Sent",
    [WorkflowStatusEnum.RevisionRequested]: "Revision-Requested",
    [WorkflowStatusEnum.Shipped]: "Shipped",
    [WorkflowStatusEnum.Archived]: "Archived",
  };
  workflowStatusList!: Record<number, string>;
  isLoading = false;

  constructor(
    private _taskManagement: TaskManagementService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _workflowService: ProjectWorkflowService,
    private _profileFormService: ProfileFormService,
    private _domSanitizer: DomSanitizer, //
    private _msalApisService: MsalApiService
  ) {}

  ngOnInit() {
    this.getWorkflowStatusList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["myTasks"] && changes["myTasks"].previousValue !== undefined) {
      this.myTasks = changes["myTasks"].currentValue;
      this.getAllTaskList(this.lazyLoadEvent);
    }
    if (
      changes["archivedTasks"] &&
      changes["archivedTasks"].previousValue !== undefined
    ) {
      this.archivedTasks = changes["archivedTasks"].currentValue;
      this.getAllTaskList(this.lazyLoadEvent);
    }
  }

  triggerFunction(taskType?: number) {
    if (taskType) {
      this.taskType = taskType;
    }
    this.getSwimLanes(this.taskType);
    // this.getAllTaskList(globalFilterValue);
  }

  getWorkflowStatusList() {
    this._workflowService.getWorkflowStatusList().subscribe({
      next: res => {
        this.workflowStatusList = {};
        const statusEnums: Record<number, string> = {};
        if (res?.data) {
          this.getSwimLanes(this.taskType);
          res.data.forEach((status: { status: string; id: number }) => {
            if (status.id !== 9) {
              statusEnums[status.id] = status.status;
            }
          });
          this.workflowStatusList = statusEnums;
        }
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Status List");
      },
    });
  }

  getSwimLanes(taskType: number) {
    this.activeListing.clear();
    this._taskManagement.getSwimLanes().subscribe({
      next: res => {
        this.swimLanes = [];
        if (res.data != null && res.data.length > 0) {
          res.data.forEach(task => {
            if (taskType == task.taskType) {
              if (taskType == TaskTypeEnum.Sales) {
                task.name = String(
                  EnumSalesTaskStatus[
                    task.status as unknown as keyof typeof EnumSalesTaskStatus
                  ]
                );
                this.swimLanes!.push(task);
              } else {
                if (this.workflowStatusList?.[task.status]) {
                  task.name = this.workflowStatusList[task.status];
                  this.swimLanes!.push(task);
                }
              }
            }
          });

          this.getAllTaskList(this.globalFilter);
        }
      },
      error: () => {
        this._toastr.error("Error", "Error Fetching Swim lanes");
      },
    });
  }

  getAllTaskList(globalFilterValue?: GenericFilterRequestDto[]) {
    this._loaderService.setLoaderState(true);
    const filter = [];
    if (this.taskType) {
      filter.push({
        columnName: "TaskType",
        matchMode: "equals",
        tableName: "UserTasks",
        value: this.taskType.toString(),
      });
    }

    const request: GenericRequestKanbanDto = {
      skip: 0,
      take: this.totalRecords || 1000,
      filters: globalFilterValue ? [...globalFilterValue, ...filter] : filter,
      skipPagination: true,
      sort: [],
      listViewType: ViewTypeEnum.Kanban,
      myTask: this.myTasks,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      archivedTask: this.archivedTasks,
      searchText: this.headerSearchText ?? "",
    };

    this._taskManagement.getAllProjectWorkFlowTaskList(request).subscribe({
      next: async res => {
        if (res?.data) {
          this.totalRecords = res.totalRecords ?? 0;
          this.swimLanes.forEach(status => {
            if (status.isActive) {
              this.activeListing.set(
                status.name.toLocaleLowerCase().replace(" ", ""),
                []
              );
            }
          });
          res.data.forEach(task => {
            if (this.taskType == task.taskType && task.statusText) {
              const statusTxt = task.statusText
                .toLocaleLowerCase()
                .replace(" ", "");
              if (this.activeListing.get(statusTxt)) {
                this.activeListing.get(statusTxt)!.push(task);
              }
            }
          });
          this._loaderService.setLoaderState(false);
        } else {
          this._loaderService.setLoaderState(false);
        }
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Listed Tasks");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getNameByTaskStatus(text: string) {
    const result = this.swimLanes.filter(
      item =>
        item.name.toLowerCase().replace(" ", "") ===
        text.toLowerCase().replace(" ", "")
    );
    return result[0];
  }

  getNameByTaskStatusFromEnums(text: string) {
    const record = this.getNameByTaskStatus(text);
    if (!record) {
      return;
    }

    if (record.taskType === TaskTypeEnum.Sales) {
      return this.taskStatusKeyPairsSales[record.status] || "Unknown Status";
    } else {
      return this.workflowStatusList[record.status] || "Unknown Status";
    }
  }

  // getNumberByTaskTitle(text: string, statuses: any) {
  //   if (statuses instanceof Map) {
  //     for (const [index, status] of statuses.entries()) {
  //       if (
  //         typeof status === 'string' &&
  //         status.toLowerCase() === text.toLowerCase()
  //       ) {
  //         return index;
  //       }
  //     }
  //   } else {
  //     for (const [key, value] of Object.entries(statuses)) {
  //       if (
  //         typeof value === 'string' &&
  //         value.toLowerCase() === text.toLowerCase()
  //       ) {
  //         return Number(key);
  //       }
  //     }
  //   }
  //   return 0;
  // }

  dragStart(task: GetAllTaskResponse) {
    if (!task.isExternal) {
      this.draggedTask = task;
    }
  }

  drop(list: string) {
    if (this.draggedTask) {
      const currentStatus = this.draggedTask.statusText;
      if (currentStatus.toLowerCase() !== list.toLowerCase()) {
        const updateStatus = this.getNameByTaskStatus(list);
        this._taskManagement
          .updateStatus(this.draggedTask.taskId, updateStatus.status)
          .subscribe({
            next: async res => {
              if (res?.data) {
                this.getAllTaskList(this.globalFilter);
              }
            },
            error: () => {
              this._toastr.error("Error", "Unable to update Tasks");
              this._loaderService.setLoaderState(false);
            },
          });
      }

      this.draggedTask = null;
    }
  }

  closeTaskDetailModal(event: {
    added: boolean;
    actionType: "Add" | "Edit";
    hasFormChanged: boolean;
  }) {
    this.displayTaskDetailModal = false;
    if (event.hasFormChanged || event.actionType === "Add") {
      this.getAllTaskList(this.lazyLoadEvent);
    }
  }

  redirectToTaskSummary(task: number) {
    this.displayTaskDetailModal = true;
    this.taskIdSelected = task;
  }

  redirectToEditTask(task: number) {
    this.displayAddTaskModal = true;
    this.taskIdSelected = task;
  }

  showEditTask() {
    this.showEditTaskModal = !this.showEditTaskModal;
  }

  showTaskDetailModal() {
    this.displayTaskDetailModal = true;
  }

  getColor(name: string) {
    return getColorForName(name);
  }

  getTextColor(name: string) {
    return getTextColorForName(name);
  }

  isTaskPriority(pirorityId: number, type: PriorityTypeEnums): boolean {
    return pirorityId === type;
  }

  getActiveListingArray() {
    return Array.from(this.activeListing.entries()).map(([key, value]) => ({
      key,
      value,
    }));
  }

  trackByKey(
    index: number,
    item: { key: string; value: GetAllTaskResponse[] }
  ) {
    return item.key;
  }

  isPriorityType(value: number) {
    return Object.values(PriorityTypeEnums).includes(value);
  }

  @HostListener("document:mousemove", ["$event"])
  onMouseMove(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const avatarGroup = target.closest(".circle-name");
    const popoverElement = target.closest(".p-popover");

    if (!avatarGroup && !popoverElement && this.avatarPopover?.overlayVisible) {
      this.hideAvatarPopover();
    }
  }

  getTooltipContent(obj: number | null | undefined, assignedTo: string) {
    if (obj && obj > 0) {
      // Find user from the assigned users list by matching name
      const user = this.allAssignedUserList.find(u => u.name === assignedTo);

      if (user) {
        // Use the user data from the list instead of making API call
        this.userAvatorDetails.name = user.name ?? "";
        this.userAvatorDetails.email = user.loginEmail ?? "";
        this.userAvatorDetails.personalNumber = user.personalNumber ?? "";
        this.userAvatorDetails.locationName = user.locationName ?? "";
        this.userAvatorDetails.profileImageUrl =
          "../../../assets/images/avatar-default.webp";

        // Fetch profile picture
        if (user.loginEmail) {
          this.fetchUserProfile(user.loginEmail);
        }
      } else {
        // Fallback to API call if user not found in list
        this.getUserAvatarDetailsByUserId(obj);
      }
    }
  }

  onAvatarLeave() {
    this.clearAvatarDetails();
    this.currentAvatarTarget = null;
  }

  clearAvatarDetails() {
    this.userAvatorDetails = {} as avatarUserDetailsDto;
    this.userAvatorDetails = {
      name: "",
      email: "",
      personalNumber: "",
      locationName: "",
      profileImageUrl: "../../../assets/images/avatar-default.webp",
    } as avatarUserDetailsDto;
  }

  getUserAvatarDetailsByUserId(userId: number) {
    this.isLoading = true;
    this._profileFormService.GetUserAvatarDetailsByUserId(userId).subscribe({
      next: async (res: GenericResponseDto<GetUserAvatarDetailsDto>) => {
        if (res.data != null) {
          this.userAvatorDetails.name = res.data.name ?? "";
          this.userAvatorDetails.email = res.data.email ?? "";
          this.userAvatorDetails.personalNumber =
            res.data.personnelNumber ?? "";
          this.userAvatorDetails.locationName = res.data.locationName ?? "";
          this.userAvatorDetails.profileImageUrl =
            "../../../assets/images/avatar-default.webp";
          this.fetchUserProfile(res.data.email ?? "");
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  fetchUserProfile(loginEmail: string): void {
    this._msalApisService.getUserProfilePicture(loginEmail).subscribe({
      next: (res: Blob) => {
        const urlCreator = window.URL || window.webkitURL;
        this.userAvatorDetails.profileImageUrl =
          this._domSanitizer.bypassSecurityTrustUrl(
            urlCreator.createObjectURL(res)
          );
        this.isLoading = false;
      },
      error: () => {
        this.userAvatorDetails.profileImageUrl =
          "../../../assets/images/avatar-default.webp";
        this.isLoading = false;
      },
    });
  }

  showAvatarPopover(
    event: MouseEvent,
    userId: number | null | undefined,
    userName: string
  ): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    this.currentAvatarTarget = event.currentTarget as HTMLElement;
    this.getTooltipContent(userId, userName);

    // Use PrimeNG's built-in positioning with target element
    if (this.avatarPopover) {
      this.avatarPopover.show(event, this.currentAvatarTarget);
    }
  }

  hideAvatarPopover(): void {
    this.hideTimeout = setTimeout(() => {
      if (this.avatarPopover) {
        this.avatarPopover.hide();
      }
      this.onAvatarLeave();
    }, 200);
  }

  keepPopoverOpen(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  showContactDialog(client: string) {
    if (client !== "") {
      this.emitShowContactDialog.emit(client);
    }
  }

  populateContactAddedInfo(buyer: string) {
    this.taskHeaderEdit?.popolateBuyerNameAfterContactAdded(buyer);
  }
}
